/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SettlePendingPaymentDto
 */
export interface SettlePendingPaymentDto {
    /**
     * 
     * @type {number}
     * @memberof SettlePendingPaymentDto
     */
    pendingPaymentId: number;
    /**
     * 
     * @type {number}
     * @memberof SettlePendingPaymentDto
     */
    tipAmount: number;
}

/**
 * Check if a given object implements the SettlePendingPaymentDto interface.
 */
export function instanceOfSettlePendingPaymentDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pendingPaymentId" in value;
    isInstance = isInstance && "tipAmount" in value;

    return isInstance;
}

export function SettlePendingPaymentDtoFromJSON(json: any): SettlePendingPaymentDto {
    return SettlePendingPaymentDtoFromJSONTyped(json, false);
}

export function SettlePendingPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SettlePendingPaymentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pendingPaymentId': json['pendingPaymentId'],
        'tipAmount': json['tipAmount'],
    };
}

export function SettlePendingPaymentDtoToJSON(value?: SettlePendingPaymentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pendingPaymentId': value.pendingPaymentId,
        'tipAmount': value.tipAmount,
    };
}

